// import Splash from 'Pages/Splash';
import SecureDownload from 'Pages/SecureDownload';
import SiteProfile from "Pages/Site/Profile";

export default [
    // { path: '/', component: Splash, guards: ['guest'] },
    { path: '/secure-download/:id', component: SecureDownload },
    { path: '/profile', component: SiteProfile, guards: ['auth', 'two-factor-verified', 'profile-completed'], feature: 'allow_profile_change' },
];
